import { render, staticRenderFns } from "./OfferInfo.vue?vue&type=template&id=23cd78cc&scoped=true"
import script from "./OfferInfo.vue?vue&type=script&lang=js"
export * from "./OfferInfo.vue?vue&type=script&lang=js"
import style0 from "./OfferInfo.vue?vue&type=style&index=0&id=23cd78cc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cd78cc",
  null
  
)

export default component.exports